import { render, staticRenderFns } from "./MontageOverview.vue?vue&type=template&id=c95a161e"
import script from "./MontageOverview.vue?vue&type=script&lang=js"
export * from "./MontageOverview.vue?vue&type=script&lang=js"
import style0 from "./MontageOverview.vue?vue&type=style&index=0&id=c95a161e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports